import { createWebHistory, createRouter } from "vue-router"
import Home from "@/views/Home.vue"
import Login from "@/views/Login.vue"
import ConsoleReport from "@/views/ConsoleReport"
import Shift from "@/views/Shift"
import CreateStaff from "@/views/craeteStaff"
import EditShift from "@/views/EditShift"
import CollectionEntery from "@/views/ColectionEntry"
import collectionNewEntery from "@/views/collectionNewEntery"
import IncenerationConsoleEntery from "@/views/IncenerationConsoleEntery"
import IncenerationNewEntery from "@/views/IncinerationNewEntery"
import upadtePassowrd from "@/views/updatePassword"
import updateProfile from "@/views/updateProfile"
import user from "@/views/users"
import Craeteuser from "@/views/CreateUsers"
import EditUser from "@/views/EditUser"
import role from "@/views/Role"
import CraeteRole from "@/views/CreateRole"
import UpdateRole from "@/views/UpdateRole"
import logout from "@/views/logout"
import DailyRoaster from "@/views/DailyRoaster"
import CreateRoaster from '@/views/CreateRoaster'
import updateRoaster from '@/views/UpdateDailyRoaster'
import Hospital from '@/views/Hospital'
import CreateHospital from '@/views/CraeteHospital'
import UpdateHospital from '@/views/UpdateHospital'
import Staff from '@/views/Staff'
import CreateStaffs from '@/views/CreateStaffs'
import UpdateStaffs from '@/views/updatestaffs'
import Tehsil from '@/views/Tehsil'
import UpdateTehsils from '@/views/UpdateTehsils'
import DateRangeReport from '@/views/Report/DateRangeReport'
import QuaterlyReport from '@/views/Report/QuaterlyReport'
import CreateTehsils from '@/views/CreateTehsils'
import City from '@/views/SetupCity'
import createCity from '@/views/CraeteSetupCity'
import updateSetupCity from '@/views/updateSetupCity'
import QuaterYearly from '@/views/Report/QuaterYearly'
import QuaterMonthly from '@/views/Report/QuaterMonthly'
import QuaterWeek from '@/views/Report/QuaterWeek'
import TweentyFourHoursReport from '@/views/Report/TweentyFourHoursReport'
import sops from '@/views/sop/sop'
import createsops from '@/views/sop/CreateSops'
import viewSops from '@/views/sop/viewSops'
import InfectiousWasteMonitoringReport from '@/views/Report/InfectiousWasteMonitoringReport'
import GenerateDisposalPerformanceReport from '@/views/Report/GenerateDisposalPerformanceReport'
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/console-report",
    name: "report",
    component: ConsoleReport,
    meta: {
      requiresAuth: true,
      requiresPermission: "can view disposal console",
    },
  },
  {
    path: "/edit-:id", // Define the route with a parameter ':id'
    name: "EditShift",
    component: EditShift, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can update shift" },
  },
  {
    path: "/logout", // Define the route with a parameter ':id'
    name: "logout",
    component: logout, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can update shift" },
  },
  //report 
  {
    path: "/GenerateDisposalPerformanceReport", // Define the route with a parameter ':id'
    name: "GenerateDisposalPerformanceReport",
    component: GenerateDisposalPerformanceReport, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate disposal performance report" },
  },
  {
    path: "/DateRangeReport", // Define the route with a parameter ':id'
    name: "DateRangeReport",
    component: DateRangeReport, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate date range report" },
  },
  {
    path: "/QuaterYearly", // Define the route with a parameter ':id'
    name: "QuaterYearly",
    component: QuaterYearly, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate yearly report" },
  },
  {
    path: "/InfectiousWasteMonitoringReport", // Define the route with a parameter ':id'
    name: "InfectiousWasteMonitoringReport",
    component: InfectiousWasteMonitoringReport, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate infectious waste monitoring report" },
  },
  {
    path: "/QuaterMonthly", // Define the route with a parameter ':id'
    name: "QuaterMonthly",
    component: QuaterMonthly, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate monthly report" },
  },
  {
    path: "/QuaterWeek", // Define the route with a parameter ':id'
    name: "QuaterWeek",
    component: QuaterWeek, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate weekly report" },
  },
  {
    path: "/QuaterlyReport", // Define the route with a parameter ':id'
    name: "QuaterlyReport",
    component: QuaterlyReport, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate quarterly report" },
  },
  {
    path: "/TweentyFourHoursReport", // Define the route with a parameter ':id'
    name: "TweentyFourHoursReport",
    component: TweentyFourHoursReport, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can generate 24 hours progress report" },
  },

  //sop
  {
    path: "/sops", // Define the route with a parameter ':id'
    name: "sops",
    component: sops, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can see sop setup" },
  },
  {
    path: "/createsops", // Define the route with a parameter ':id'
    name: "createsops",
    component: createsops, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can create sop" },
  },
  {
    path: "/viewSops", // Define the route with a parameter ':id'
    name: "viewSops",
    component: viewSops, // Your component for editing shifts
    meta: { requiresAuth: true, requiresPermission: "can see sop" },
  },

  //user
  {
    path: "/user",
    name: "user",
    component: user,
    meta: { requiresAuth: true, requiresPermission: "can view users setup" },
  },
  {
    path: "/createusers",
    name: "CreateUser",
    component: Craeteuser,
    meta: { requiresAuth: true, requiresPermission: "can create user" },
  },
  {
    path: "/editUser-:id",
    name: "EditUser",
    component: EditUser,
    meta: { requiresAuth: true, requiresPermission: "can update user" },
  },
  // role
  {
    path: "/role",
    name: "role",
    component: role,
    meta: { requiresAuth: true, requiresPermission: "can view roles setup" },
  },
  {
    path: "/createrole",
    name: "createrole",
    component: CraeteRole,
    meta: { requiresAuth: true, requiresPermission: "can create role" },
  },
  {
    path: "/updaterole-:id",
    name: "updaterole",
    component: UpdateRole,
    meta: { requiresAuth: true, requiresPermission: "can update role" },
  },
  //shit
  {
    path: "/shift",
    name: "shift",
    component: Shift,
    meta: { requiresAuth: true, requiresPermission: "can view shifts setup" },
  },
  {
    path: "/craete-staff",
    name: "createStaff",
    component: CreateStaff,
    meta: { requiresAuth: true, requiresPermission: "can create shift" },
  },
  //DailyRoaster
  {
    path: "/dailyroaster",
    name: "DailyRoaster",
    component: DailyRoaster,
    meta: { requiresAuth: true, requiresPermission: "can view daily roasters setup" },
  },
  // Hospital
  {
    path: "/Hospital",
    name: "Hospital",
    component: Hospital,
    meta: { requiresAuth: true, requiresPermission: "can view hospitals setup" },
  },
  {
    path: "/craetehospital",
    name: "craetehospital",
    component: CreateHospital,
    meta: { requiresAuth: true, requiresPermission: "can create hospital" },
  },
  {
    path: "/updatehospital-:id",
    name: "upadteHospital",
    component: UpdateHospital,
    meta: { requiresAuth: true, requiresPermission: "can update hospital" },
  },
  {
    path: "/createroaster",
    name: "createroaster",
    component: CreateRoaster,
    meta: { requiresAuth: true, requiresPermission: "can create daily roaster" },
  },
  {
    path: "/updateroaster-:id",
    name: "updateRoaster",
    component: updateRoaster,
    meta: { requiresAuth: true, requiresPermission: "can update daily roaster" },
  },
  // Staff
  {
    path: "/Staff",
    name: "Staff",
    component: Staff,
    meta: { requiresAuth: true, requiresPermission: "can view staff types setup" },
  },
  {
    path: "/CreateStaff",
    name: "CreateStaffs",
    component: CreateStaffs,
    meta: { requiresAuth: true, requiresPermission: "can create staff type" },
  },
  {
    path: "/updatestaffs-:id",
    name: "updatestaffs",
    component: UpdateStaffs,
    meta: { requiresAuth: true, requiresPermission: "can update staff type" },
  },
  // tehsil
  {
    path: "/tehsil",
    name: "tehsil",
    component: Tehsil,
    meta: { requiresAuth: true, requiresPermission: "can view tehsils setup" },
  },
  {
    path: "/UpdateTehsils-:id",
    name: "UpdateTehsils",
    component: UpdateTehsils,
    meta: { requiresAuth: true, requiresPermission: "can update tehsil" },
  },
  {
    path: "/CreateTehsils",
    name: "CreateTehsils",
    component: CreateTehsils,
    meta: { requiresAuth: true, requiresPermission: "can create tehsil" },
  },
  //city
  {
    path: "/city",
    name: "city",
    component: City,
    meta: { requiresAuth: true, requiresPermission: "can view cities setup" },
  },
  {
    path: "/createCity",
    name: "createCity",
    component: createCity,
    meta: { requiresAuth: true, requiresPermission: "can create city" },
  },
  {
    path: "/updateSetupCity-:id",
    name: "updateSetupCity",
    component: updateSetupCity,
    meta: { requiresAuth: true, requiresPermission: "can update city" },
  },
  {
    path: "/collectionEntery",
    name: "collectionEnetery",
    component: CollectionEntery,
    meta: {
      requiresAuth: true,
      requiresPermission: "can view collection console",
    },
  },
  {
    path: "/collectionNewEntery",
    name: "collectionNewEntery",
    component: collectionNewEntery,
    meta: {
      requiresAuth: true,
      requiresPermission: "can enter new collections",
    },
  },
  {
    path: "/incinerationConsole",
    name: "incinerationConsole",
    component: IncenerationConsoleEntery,
    meta: {
      requiresAuth: true,
      requiresPermission: "can view disposal console",
    },
  },
  {
    path: "/incinerationNewEntery",
    name: "IncenerationNewEntery",
    component: IncenerationNewEntery,
    meta: { requiresAuth: true, requiresPermission: "can dispose collections" },
  },
  {
    path: "/password",
    name: "password",
    component: upadtePassowrd,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "profile",
    component: updateProfile,
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard to check authentication status before each route navigation
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem("token")

  const hasPermission = (requiredPermission) => {
    const permissions =
      JSON.parse(localStorage.getItem("authService"))?.authData?.permissions ||
      []
    const hasRequiredPermission = permissions?.some(
      (permission) => permission?.name === requiredPermission
    )
    return hasRequiredPermission
  }

  if (to.matched.some((route) => route.meta.requiresAuth) && !isAuthenticated) {
    next({ name: "Login" })
  } else if (to.name === "Login" && isAuthenticated) {
    next({ name: "Home" })
  } else if (to.matched.some((route) => route.meta.requiresPermission)) {
    const requiredPermission = to.meta.requiresPermission

    if (!(await hasPermission(requiredPermission))) {
      next({ name: "Home" })
    } else {
      // Check if the path is lowercase, and redirect if needed
      const isLowercasePath = to.path === to.path.toLowerCase()
      if (!isLowercasePath) {
        next({ path: to.path.toLowerCase(), replace: true })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
